/// <amd-module name="Wit/UI/Services/index" />
export * from "./WorkItemStateColorMetadataService";
export * from "./WorkItemTypeIconMetadataService";
